// PageDescription: 비대면진료 증상과목 카테고리 페이지
import TelemedicineCategoriesTemplate from '@/components/templates/telemedicine/category/TelemedicineCategoriesTemplate';
import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import useTelemedicineCategoriesViewModel from '@/hooks/telemedicine/useTelemedicineCategoriesViewModel';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const TelemedicineCategoriesPage = ({ client }: CustomPageProps) => {
  const viewModel = useTelemedicineCategoriesViewModel();
  return (
    <>
      <NextSeo
        title='비대면진료 예약·약 처방받기 | 증상·과목별 전화진료 - 닥터나우'
        description='비대면진료가 필요할 때 닥터나우를 이용하면 병원에서 전화가 와요! 감기, 소아과, 탈모 등 다양한 분야의 진료와 약 처방이 가능해요.'
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.CATEGORIES.path}${addQueryString({
            type: viewModel.selectedCategoryType,
          })}`,
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: '비대면진료, 비대면진료어플, 전화진료, 감기, 탈모, 소아과, 비대면약처방, 닥터나우',
          },
        ]}
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.TELEMEDICINE.CATEGORIES.path}${addQueryString({
          type: viewModel.selectedCategoryType,
        })}`}
      />
      <TelemedicineCategoriesTemplate client={client} viewModel={viewModel} />
    </>
  );
};
export default TelemedicineCategoriesPage;

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = new QueryClient();

  await useGetDiagnosisCategories.prefetchQuery(queryClient);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
